<template>
  <article class="status-card">
    <div v-if="!link">
      <h3>{{title}}</h3>
      <p>{{description}}</p>
    </div>
    <div v-else>
      <ExternalLinkButton :href="link" target="_blank" format="press">{{title}}</ExternalLinkButton>
    </div>
  </article>
</template>

<script>
import ExternalLinkButton from './Button/ExternalLinkButton.vue';

export default {
  name: 'StatusCard',
  components: {
    ExternalLinkButton
  },
  props: {
    title: String,
    description: String,
    link: String,
  },
};
</script>

<style scoped lang="scss">
.status-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 15px;

  h3 {
    font-weight: 600;
    font-size: 10px;
    color: #330e2f;
    margin: 0;
  }

  p {
    font-size: 14px;
    color: #330e2f;
    margin-top: 5px;
  }
}
</style>
